import { Component, OnInit, ViewChild, Input, ChangeDetectionStrategy, Output, EventEmitter, HostListener, inject } from '@angular/core';
import {
  ToolbarService,
  PrintService,
  SelectionService,
  EditorService,
  EditorHistoryService,
  SfdtExportService,
} from '@syncfusion/ej2-angular-documenteditor';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { DataService } from 'src/app/shared/services/data.service';
import { ToastrService } from 'ngx-toastr';
import { v4 as uuidv4 } from 'uuid';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { IRicheditComponent } from '@devinforius/i-dx-editor';
import { loadMessages, locale } from 'devextreme/localization';
import RELocalization from 'src/assets/translations/dx-rich.fr.json';
import { DocumentFormatApi } from 'devexpress-richedit/lib/model-api/formats/enum';
import { ServicesService } from 'src/app/shared/services/services.service';
import { DocumentFusionFieldsDTO, DocumentTemplate } from 'src/app/shared/models/iCourrier/document-template';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { toMergeFieldsForEditor } from 'src/app/shared/utils/merge-fields-for-editor.util';

@Component({
  selector: 'app-document-editor-simple',
  templateUrl: './document-editor-simple.component.html',
  styleUrls: ['./document-editor-simple.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToolbarService, PrintService, SelectionService, EditorService, EditorHistoryService, SfdtExportService, DatePipe],
})
export class DocumentEditorSimpleComponent implements OnInit {
  private readonly documentsService = inject(DocumentsService)
  public readonly mergeFields = toSignal(this.documentsService.getFusionsField().pipe(map(toMergeFieldsForEditor)), { initialValue: {} });

  @ViewChild('document_editor') public documenteditorcontainer: IRicheditComponent;
  public template: DocumentTemplate;
  public baseUrlDocumentEditor: string;
  public guid: uuidv4;
  public mailId: number;
  public LIST_IDS: string[] = [];
  public fusions: DocumentFusionFieldsDTO;
  public showFusion = false;
  public mousePosition: MouseEvent;
  public isFullscreen = false;
  public searchValue = '';
  public lang = localStorage.getItem('lang');
  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.mousePosition = event;
  }
  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    event.preventDefault();
  }
  @Input() set rtf(value) {
    if (value) {
      this.transformDocument(value);
    }
  }
  @Input() editMode = true;
  public enableSpellCheck = false;

  public timer;

  @Output() rtfTransformed = new EventEmitter<Blob>();
  constructor(
    public toastr: ToastrService,
    public spinner: NgxSpinnerService,
    public dataService: DataService,
    private servicesService: ServicesService
  ) {
    if (RELocalization) {
      loadMessages({ fr: RELocalization });
      locale('fr');
    }
  }

  ngOnInit(): void {
    this.generateRdGuid();
  }

  public generateRdGuid() {
    this.guid = uuidv4();
  }

  transformDocument(rtf) {
    this.spinner.show();
    const blob = new Blob([rtf], { type: 'application/rtf' });

    if (blob && blob.size > 0) {
      this.loadBlob(blob);
    } else {
      this.spinner.hide();
    }
  }

  public loadBlob(blob: Blob): void {
    if (this.documenteditorcontainer) {
      this.documenteditorcontainer.rich.openDocument(blob, 'document', DocumentFormatApi.Rtf, () => {
        this.spinner.hide();
      });
    }
  }

  getFusions() {
    this.spinner.show();
    this.LIST_IDS = [];
    this.servicesService.getFusionsFieldServices().subscribe({
      next: (res) => {
        this.fusions = res;
        const keys = Object.keys(this.fusions);

        keys.forEach((_key, index) => {
          this.LIST_IDS.push('cdk-drop-list-' + index);
        });

        this.spinner.hide();
      },
    });
  }

  public insert(variable) {
    const cursorPosition = this.documenteditorcontainer.rich.selection.start;
    this.documenteditorcontainer.rich.document.insertText(cursorPosition, variable);
  }

  public dropped(event: CdkDragDrop<string[]>) {
    const text = event.item && event.item.data;
    const cursorPosition = this.documenteditorcontainer.rich.selection.start;
    this.documenteditorcontainer.rich.document.insertText(cursorPosition, text);
  }

  sendToComponent() {
    this.documenteditorcontainer.rich.exportToFile((file) => {
      const blob = new Blob([file], { type: 'application/rtf' });
      this.rtfTransformed.emit(blob);
      this.spinner.hide();
    }, DocumentFormatApi.Rtf);
  }

  copy(event, text) {
    if (event.detail === 1) {
      this.timer = setTimeout(() => {
        navigator.clipboard.writeText(text.description).then(
          function () {
            console.info('Async: Copying to clipboard was successful!');
          },
          function (err) {
            console.error('Async: Could not copy text: ', err);
          }
        );
        this.toastr.success('La valeur ' + text.key + ' est copié dans votre presse-papier');
      }, 500);
    }
  }
}
